/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Failed_To_RejectInputs */

const en_samples_failed_to_reject = /** @type {(inputs: Samples_Failed_To_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to reject samples`)
};

const es_samples_failed_to_reject = /** @type {(inputs: Samples_Failed_To_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al rechazar muestras`)
};

/**
* | output |
* | --- |
* | "Failed to reject samples" |
*
* @param {Samples_Failed_To_RejectInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_failed_to_reject = /** @type {((inputs?: Samples_Failed_To_RejectInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Failed_To_RejectInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_failed_to_reject(inputs)
	return es_samples_failed_to_reject(inputs)
});